import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import CheckoutSummary from './CheckoutSummary';
import FiltersBlock from './FiltersBlock';
import TicketList from './TicketList';
import { media } from '../../../../styles';

import {
  SIDEBAR_WIDTH,
  MAP_HEIGHT_SMALL,
} from '../styles';

const Container = glamorous.div(props => ({
  overflow: 'hidden',
  position: 'relative',
  float: 'right',
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,
  height: '100%',
  width: SIDEBAR_WIDTH,

  boxShadow: '0 1px 2px 0 rgba(53,65,74,.3)',

  [media('sm', { isMax: true })]: {
    zIndex: 100,
    float: 'none',
    width: '100%',
    transition: 'padding-top 300ms cubic-bezier(0, 0, 0.2, 1) 0ms',
    paddingTop: props.isViewingMap ? MAP_HEIGHT_SMALL : 50,
  }
}));

const noop = () => {};

class Sidebar extends React.PureComponent {
  static propTypes = {
    currentFilters: PropTypes.object,
    eventName: PropTypes.string,
    hasFilters: PropTypes.bool,
    hasSort: PropTypes.bool,
    hasTaraFilters: PropTypes.bool,
    hasTicketAttributes: PropTypes.bool,
    isViewingMap: PropTypes.bool,
    isFetching: PropTypes.bool,
    isReady: PropTypes.bool,
    onChangeSort: PropTypes.func,
    onClickBuyButton: PropTypes.func,
    onClickFilters: PropTypes.func,
    onHide: PropTypes.func,
    selectedTicket: PropTypes.object,
    sortOptions: PropTypes.object,
    ticketList: PropTypes.array,
  };

  static defaultProps = {
    currentFilters: {},
    eventName: undefined,
    hasFilters: false,
    hasSort: false,
    hasTaraFilters: false,
    hasTicketAttributes: false,
    isViewingMap: false,
    isFetching: false,
    isReady: false,
    onChangeSort: noop,
    onClickBuyButton: noop,
    onClickFilters: noop,
    onHide: noop,
    selectedTicket: {},
    sortOptions: {},
    ticketList: [],
  };


  render() {
    return (
      <Container
        isViewingMap={this.props.isViewingMap}
      >
        <FiltersBlock
          {...this.props.currentFilters}
          eventName={this.props.eventName}
          venue={this.props.venue}
          hasFilters={this.props.hasFilters}
          hasSort={this.props.hasSort}
          hasTaraFilters={this.props.hasTaraFilters}
          isFetching={this.props.isFetching}
          isViewingMap={this.props.isViewingMap}
          hasNoRecommendedTickets={this.props.hasNoRecommendedTickets}
          shouldShowAllTickets={this.props.shouldShowAllTickets}
          sortOptions={this.props.sortOptions}
          onChangeSort={this.props.onChangeSort}
          onClickFilters={this.props.onClickFilters}
          ticketList={this.props.ticketList}
          seaticsFilterOptions={this.props.seaticsFilterOptions}
        />

        <TicketList
          isReady={this.props.isReady}
          hasTicketAttributes={this.props.hasTicketAttributes}
          onSelectTicket={this.props.onSelectTicket}
          selectedTicket={this.props.selectedTicket}
          ticketList={this.props.ticketList}
        />

        <CheckoutSummary
          selectedTicket={this.props.selectedTicket}
          onClickBuyButton={this.props.onClickBuyButton}
          onSelectQuantity={this.props.onSelectQuantity}
          onHide={this.props.onHide}
        />
      </Container>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/features/SeaticsMapWidget/Sidebar/Sidebar.js